module.exports = __webpack_public_path__ + "static/img/5.f3b6b6e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/4/eng/5.png
// module id = CmzD
// module chunks = 0